import React from 'react'

import startup from '../images/startup.svg'
import magnifier from '../images/magnifier.svg'
import handShake from '../images/hand-shake.svg'


export default function(){
    return(
        <div id="pilares" style={{backgroundColor: "#fff"}}>
      
          <div style={{padding: "5%"}}>
      
            <div className="text-center" style={{color: "rgb(68, 1, 91)"}}>
              <h3 className="font-weight-bold">Nossos pilares</h3>
            </div>
      
          
            <div className="row text-center col-lg-10 mx-auto">
      
              {/*Empreendedorismo*/}
              <div className="card col-md-4 px-0 mt-2 border-0 ">
                <a style={{textDecoration: "none"}} href="/empreendedorismo">
                  <div className="card-header" style={{backgroundColor: "#c0512c", height: "50px"}}>
        
                    <div className="bg-white rounded-circle mx-auto row"
                      style={{width: "50px", height: "50px", border: "1px solid  #c0512c"}}>
                      <img alt="" className="my-auto mx-auto" style={{width: "30px", height: "30px"}} src={startup}/>
                    </div>
        
                  </div>
                  <div className="card-body" style={{color: "#c0512c", borderLeft: "1px solid #eee", borderRight: "1px solid #eee"}}>
                    <h5 className=" font-weight-bold">Empreendedorismo</h5>
                    <p className="card-text">Através de programa contínuo de aceleração de ideias e incubação de startups, o INOVE
                      fomenta uma nova geração de empreendedores e empresas que nascem e já se estabelecem na região.</p>
                  </div>
                  <button type="button" className="btn btn-lg btn-block text-white btn-sm rounded-0"
                    style={{backgroundColor: "#c0512c"}}>
                    Saiba mais
                  </button>
                </a>
              </div>

              {/* Pesquisa*/}
              
              <div className="card col-md-4 px-0 mt-2 border-0">
                <a style={{textDecoration: "none"}} href="/pesquisa">
                <div className="card-header" style={{backgroundColor: "#1b8081", height: "50px"}}>
      
                  <div className="bg-white rounded-circle mx-auto row"
                    style={{width: "50px", height: "50px", border: "1px solid  #1b8081"}}>

                    <img alt="" className="my-auto mx-auto" style={{width: "30px", height: "30px"}} src={magnifier}/>
                  </div>
      
                </div>
                <div className="card-body" style={{color: "#1b8081", borderLeft: "1px solid #eee", borderRight: "1px solid #eee"}}>
                  <h5 className="font-weight-bold">Pesquisa</h5>
                  <p className="card-text">Esse eixo compreende laboratórios de informática para execução de projetos de pesquisa
                    e
                    desenvolvimento, sejam financiados por editais públicos, diretamente por empresas, ou através de programas
                    de
                    incentivo tais como Lei do Bem e Lei de Informática</p>
                </div>
                
                <button type="button" className="btn btn-lg btn-block text-white btn-sm rounded-0"
                  style={{backgroundColor: "#1b8081"}}>Saiba
                  mais</button>
                </a>
              </div>
              
              {/* Empresarial*/}
              <div className="card col-md-4 px-0 mt-2 border-0">
                <a style={{textDecoration: "none"}} href="/empresarial">
                  <div className="card-header" style={{backgroundColor: "#911854", height: "50px"}}>
        
                    <div className="bg-white rounded-circle mx-auto row"
                      style={{width: "50px", height: "50px", border: "1px solid  #911854"}}>
                      <img alt="" className="my-auto mx-auto" style={{width: "30px", height: "30px"}} src={handShake}/>
                    </div>
        
                  </div>
                  <div className="card-body" style={{color: "#911854", borderLeft: "1px solid #eee", borderRight: "1px solid #eee"}}>
                    <h5 className=" font-weight-bold">Empresarial</h5>
                    <p className="card-text">O ambiente de empresas compreende espaços que atendem desde empresas de médio porte a
                      empreendedores individuais, através do seu espaço de coworking.</p>
                  </div>
                
                  <button type="button" className="btn btn-lg btn-block text-white btn-sm rounded-0"
                    style={{backgroundColor: "#911854"}}>Saiba
                    mais</button>
                </a>
              </div>
            </div>
          </div>
        </div>
    );
}